/**
 * @generated SignedSource<<a67c94cc5199aba4117fc6b526e12ce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personaListGetQuery$variables = {};
export type personaListGetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"personaPaginationFragment">;
};
export type personaListGetQuery = {
  response: personaListGetQuery$data;
  variables: personaListGetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "sortingOpt",
    "value": {}
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "personaListGetQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "personaPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "personaListGetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "PersonaConnection",
        "kind": "LinkedField",
        "name": "getOwnPersonas",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonaEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Persona",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nickname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": "getOwnPersonas(first:10,sortingOpt:{})"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "sortingOpt"
        ],
        "handle": "connection",
        "key": "Edges_getOwnPersonas",
        "kind": "LinkedHandle",
        "name": "getOwnPersonas"
      }
    ]
  },
  "params": {
    "cacheID": "426488e8c766174b91b22fcd78851cbc",
    "id": null,
    "metadata": {},
    "name": "personaListGetQuery",
    "operationKind": "query",
    "text": "query personaListGetQuery {\n  ...personaPaginationFragment\n}\n\nfragment personaPaginationFragment on Query {\n  getOwnPersonas(first: 10, sortingOpt: {}) {\n    edges {\n      node {\n        id\n        nickname\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "e18d40b24175bd8da512704b771596be";

export default node;
